import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import SvgIcon from '../Icons';

import './index.sass';


const Breadcrumbs = ({ breadcrumbs, className }) => {

  const linksList = breadcrumbs.map( (breadcrumb, index) => (
    <div className="breadcrumbs__link-wrapper" key={breadcrumb.label}>
      { index === breadcrumbs.length - 1
        ?
          <div className="breadcrumbs__link breadcrumbs__last-one-link breadcrumbs__link--disabled">
            { breadcrumb.label }
          </div>
        :
          <Fragment>
            <a className="breadcrumbs__link" href={breadcrumb.path}>
              { breadcrumb.label }
            </a>
            <span className="breadcrumbs__separator">/</span>
          </Fragment>
      }
    </div>
  ));

  return (
    <div className={`breadcrumbs ${className || ''}`}>
      <div className="breadcrumbs__wrapper">{ linksList }</div>
    </div>
  );
};

export default Breadcrumbs;

Breadcrumbs.defaultProps = {
  breadcrumbs: [],
};

Breadcrumbs.propTypes = {
  breadcrumbs: PropTypes.array,
};
